"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3007],{

/***/ 62204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgGreenCheck(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.295 15.875l-4.17-4.17-1.42 1.41 5.59 5.59 12-12-1.41-1.41-10.59 10.58z",
    fill: "#7D8F5C"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgGreenCheck);

/***/ }),

/***/ 63007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ foodProgram_FindTheRightProgram; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./public/artifacts/icons/green-check.svg
var green_check = __webpack_require__(62204);
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/find-the-right-program/boost-your-canteen.png
/* harmony default export */ var boost_your_canteen = ({"src":"/_next/static/media/boost-your-canteen.4153049f.png","height":316,"width":339,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAb1BMVEVMaXHCrpp1bnJBU1P+/+nx9OF4ZEx3d33q6tbVy7NYbHKvi3ORemRjNBX//////+efWTX///DY6dDHx67SzrFwUDlyj5Gzq6iZlZN8h59yjISSiINRWmphOjalsLuJblamqaKvlXm4qZX8+d2VcmM5UPjaAAAAH3RSTlMA/f2FtC77HAYl/v2OUg6ahmZpvfr7/fv6+n/72nH4/K9JFAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAD9JREFUeJwFwYUBgDAAwLDOmOHuDPn/RhJwxngLeN3fV5ZD9Yo4ZFeBfibxzbGmScsmT3ngujSGsFso21Upyw9dFQMjbJlGtgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/find-the-right-program/daily.png
/* harmony default export */ var daily = ({"src":"/_next/static/media/daily.b0152a76.png","height":316,"width":312,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAclBMVEVMaXHUvpru8O/p497y8s3p48rBs5fg5dDn58319vWCdmTh5+mej3T7/+nz88e8pHH6/eGSck3x9dn1+dna2tHL0tLd4tPS0MeChXr8///a4OOzmXOujmD///vNxLqhkGXu48rYu4xITVWenpjOv6R0e4BFiDxLAAAAHHRSTlMATWj8fsD7DAP++836Uy5B2v3MjRzV3/39wp/90YLP6gAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAERJREFUeJwFwQUCgCAAALFDQNLu7v9/0Q2wxljAqLrvQgLN5twut4TylPuQugm9xvsZv0C2Vt7HdwaVHsulW7B5IYThB3btA4RXALx5AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/find-the-right-program/regular.png
/* harmony default export */ var regular = ({"src":"/_next/static/media/regular.2359fb9f.png","height":316,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAeFBMVEXe3t6cinWZbU5+g3u8s6NzZ0aVfHZMaXFyd4XKoYV+WEv//+vy9tr7/+dMEyGKeGucnof8/+L4/NyYlIdyfoljRzH6/+MwDRV7ak+ll47CpHVcUiv//+za3b/Jx72QfGqTgHbIqpCnrZhwRiaEb1igh1f//+6sknqUOLHwAAAAH3RSTlMC/v5t+/3XAAj8Xyd2QDWrnGJvPtSznzrT+vv6vL39EZtbmwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEdJREFUeJwFwQcCgCAMBLADgRYX7q2A8/8/NAEIYCYC6t2YLgGaV2hxnCm2qGW0d4/Br4+V14RChcXOvgLl6vPBMUBZO5aMH38aA+QDqFbHAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/artifacts/images/food-program-page/find-the-right-program/special-events.png
/* harmony default export */ var special_events = ({"src":"/_next/static/media/special-events.9a2bbe0c.png","height":316,"width":340,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAaVBMVEX/m5upmJ/7/uWJeXrr5szw6tu5uc7W6tbcxrTu8uTTj3bjinTpYFPo496pc2uinptUUljk2NC7uLbcxrHIrJBGTWj//+wpL1exwrzCrKr//+PHsKXls5vefG7m39VrTlX//+jMvr3IztZJlxKuAAAAG3RSTlMB/K/7/hn8CPosKVxSZ7lsiO54X/v7Yfu4+pWlCyZOAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAPklEQVR4nAXBhwGAIBAAsaM/NuyKXfcf0gSIMTrAaWuvrobtMaOIFGg77W8+SuZvMV6dFWG9lc8NEIa+TYEfTd0CtoSU0MUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./src/static_pages/foodProgram/Utils.tsx
var Utils = __webpack_require__(54397);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/foodProgram/FindTheRightProgram.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: ",
        "px;\n\n  align-items: start;\n  justify-items: center;\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    gap: ",
        "px;\n  }\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  flex-shrink: 0;\n  width: 200px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: start;\n  flex-direction: column;\n  gap: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var IDEAS = [
    {
        titleKey: "findTheRightProgram.dailyCatering.title",
        benefitKeys: "findTheRightProgram.dailyCatering.benefits",
        image: daily
    },
    {
        titleKey: "findTheRightProgram.regularCatering.title",
        benefitKeys: "findTheRightProgram.regularCatering.benefits",
        image: regular
    },
    {
        titleKey: "findTheRightProgram.specialCatering.title",
        benefitKeys: "findTheRightProgram.specialCatering.benefits",
        image: special_events
    },
    {
        titleKey: "findTheRightProgram.boostYourCanteen.title",
        benefitKeys: "findTheRightProgram.boostYourCanteen.benefits",
        image: boost_your_canteen
    }, 
];
var FindTheRightProgram = function(props) {
    var theme = (0,styled_components_browser_esm.useTheme)();
    var t = (0,useTranslation/* useTranslation */.$)("food_program").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "section",
        textAlign: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Utils/* FoodProgramH2 */.s, {
                    mb: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                        t: t,
                        i18nKey: "findTheRightProgram.title",
                        components: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                as: "span",
                                color: theme.palette.secondary[400]
                            }, "1"), 
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ideas, {
                    children: IDEAS.map(function(param) {
                        var titleKey = param.titleKey, benefitKeys = param.benefitKeys, image = param.image;
                        var i18Benefits = t(benefitKeys, {
                            returnObjects: true
                        });
                        var benefits = Array.isArray(i18Benefits) ? i18Benefits : [];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Idea, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaImage, {
                                    src: image
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaTitle, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                        t: t,
                                        i18nKey: titleKey,
                                        components: {
                                            "1": /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitItems, {
                                    children: benefits.map(function(benefit) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                            alignSelf: "flex-start",
                                            display: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(green_check/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                                    fontSize: 16,
                                                    ml: 1,
                                                    children: benefit
                                                })
                                            ]
                                        }, benefit);
                                    })
                                })
                            ]
                        }, titleKey);
                    })
                })
            })
        ]
    }));
};
var Ideas = styled_components_browser_esm["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(9);
});
var Idea = styled_components_browser_esm["default"].div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var IdeaImage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: props.src,
        width: 160,
        height: 158,
        objectFit: "contain",
        alt: ""
    });
};
var IdeaTitle = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, (0,_object_spread/* default */.Z)({
        lineHeight: {
            xs: 1.5,
            sm: 1.5
        },
        fontSize: 20,
        component: "h3",
        fontWeight: 600
    }, props));
};
var BenefitItems = styled_components_browser_esm["default"].div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
/* harmony default export */ var foodProgram_FindTheRightProgram = (FindTheRightProgram);


/***/ })

}]);